import cn from 'classnames'
import { Tile } from '@mc/design-system'
import { paths } from '@mc/paths'

import { Article } from 'types/data'
import Link from 'components/Link/CustomLink'
import Image from 'components/LegacyImage'
import styles from './ArticleTile.module.scss'
import { useSubcategoryPageEvents } from '../../utils'

interface ArticleTileProps {
  article: Article
  colIdx: number
}

export const ArticleTile = ({ article, colIdx }: ArticleTileProps) => {
  const { trackArticleTileClicked } = useSubcategoryPageEvents()

  if (
    !article ||
    !article.heroImage ||
    !article.heroImage.url ||
    !article.slug
  ) {
    return <></>
  }

  return (
    <div className={styles.tile}>
      <Link
        ariaHidden
        href={paths.article(article.slug)}
        tabIndex={-1}
        onClick={() => trackArticleTileClicked(colIdx, article?.slug || '')}
        passHref
        className='mc-mt-3 d-flex'
      >
        <Tile aspectRatio='auto' className={styles.tileContent}>
          <Image
            objectFit='cover'
            src={article.heroImage.url}
            className='mc-corners--3'
            layout='fill'
            alt=''
          />
        </Tile>
      </Link>
      <div className={cn('mc-mt-3 mc-mb-4', styles.instructorInfo)}>
        <p className='mc-text-h6 mc-text--3-lines'>{article.title}</p>
      </div>
    </div>
  )
}
